import QuizEvaluation from "@/components/Base/QuizEvaluation/QuizEvaluation";
import TaskEvaluation from "@/components/Base/TaskEvaluation/TaskEvaluation";
import SelectAnswerEvaluation from "@/components/Base/SelectAnswerEvaluation/SelectAnswerEvaluation";
import AddFileEvaluation from "@/components/Base/AddFileEvaluation/AddFileEvaluation";

class Answer {
  constructor(val, index) {
    this.val = val;
    this.index = index;
  }
}

class EvaluationTaskView {
  constructor(evaluationTask) {
    this.id = evaluationTask.id;
    this.task = evaluationTask.task;
    this.answer = "";
    this.type = evaluationTask.type;
    this.results = evaluationTask.results;
    this.componentName = TaskEvaluation.name;
  }

  setUserAnswer(answer) {
    this.answer = answer;
  }

  hasAnswer() {
    return Boolean(this.answer);
  }
}

class EvaluationQuizView {
  constructor(evaluationQuiz) {
    this.id = evaluationQuiz.id;
    this.task = evaluationQuiz.task;
    this.answer = "";
    this.answers = evaluationQuiz.answers;
    this.type = evaluationQuiz.type;
    this.results = evaluationQuiz.results;
    this.componentName = QuizEvaluation.name;
  }

  setUserAnswer(answer) {
    this.answer = answer;
  }

  hasAnswer() {
    return Boolean(this.answer);
  }
}

class EvaluationSelectAnswerView {
  constructor(evaluationQuiz) {
    this.id = evaluationQuiz.id;
    this.task = evaluationQuiz.task;
    this.answer = "";
    this.answers = evaluationQuiz.answers;
    this.type = evaluationQuiz.type;
    this.results = evaluationQuiz.results;
    this.componentName = SelectAnswerEvaluation.name;
  }

  setUserAnswer(answer) {
    this.answer = answer;
  }

  hasAnswer() {
    return Boolean(this.answer);
  }
}

class EvaluationAddFileView {
  constructor(evaluationQuiz) {
    this.id = evaluationQuiz.id;
    this.task = evaluationQuiz.task;
    this.answer = "";
    this.type = evaluationQuiz.type;
    this.results = evaluationQuiz.results;
    this.componentName = AddFileEvaluation.name;
  }

  setUserAnswer(answer) {
    this.answer = answer;
  }

  hasAnswer() {
    return Boolean(this.answer);
  }
}

class Evaluation {
  constructor(buildData) {
    this.id = buildData.id;
    this.task = buildData.task;
    this.answer = "";
    this.type = buildData.type;
    this.results = buildData.results;
  }
}

class EvaluationQuiz extends Evaluation {
  constructor(buildData) {
    super(buildData);
    this.answers = buildData.answers;
  }

  createEvaluationView() {
    return new EvaluationQuizView(this);
  }
}
class EvaluationSelectAnswer extends Evaluation {
  constructor(buildData) {
    super(buildData);
    this.answers = buildData.answers;
  }

  createEvaluationView() {
    return new EvaluationSelectAnswerView(this);
  }
}
class EvaluationTask extends Evaluation {
  constructor(buildData) {
    super(buildData);
  }

  createEvaluationView() {
    return new EvaluationTaskView(this);
  }
}
class EvaluationAddFile extends Evaluation {
  constructor(buildData) {
    super(buildData);
  }

  createEvaluationView() {
    return new EvaluationAddFileView(this);
  }
}

class EvaluationBuilder {
  setId(val) {
    this.id = val;
    return this;
  }
  setTask(val) {
    this.task = val;
    return this;
  }
  setType(val) {
    this.type = val;
    return this;
  }

  setResults(val) {
    this.results = val;
    return this;
  }

  build() {
    return new Evaluation(this);
  }
}

class EvaluationQuizBuilder extends EvaluationBuilder {
  constructor(buildData) {
    super(buildData);
  }
  setAnswers(val) {
    this.answers = val;
    return this;
  }

  build() {
    return new EvaluationQuiz(this);
  }
}

class EvaluationSelectAnswerBuilder extends EvaluationBuilder {
  constructor(buildData) {
    super(buildData);
  }

  setAnswers(val) {
    this.answers = val;
    return this;
  }

  build() {
    return new EvaluationSelectAnswer(this);
  }
}

class EvaluationAddFileBuilder extends EvaluationBuilder {
  constructor(buildData) {
    super(buildData);
  }

  build() {
    return new EvaluationAddFile(this);
  }
}

class EvaluationTaskBuilder extends EvaluationBuilder {
  constructor(buildData) {
    super(buildData);
  }

  build() {
    return new EvaluationTask(this);
  }
}

class EvaluationDeck {
  constructor(evaluations) {
    this.currentIndex = 0;
    this.evaluations =
      evaluations.filter((ev) => {
        return (
          !ev.hasOwnProperty("results") ||
          ev.results.length === 0 ||
          ev.results.some((re) => re.need_reevaluation)
        );
      }) || [];
  }

  hasEvaluations() {
    return this.evaluations.length;
  }

  setUserAnswer(answer) {
    const currentEvaluation = this.getCurrentEvaluation();
    currentEvaluation.setUserAnswer(answer);
  }

  getEvaluations() {
    return this.evaluations;
  }

  moveNextEvaluation() {
    if (!this.isLast()) {
      this.currentIndex += 1;
    }
    return this.getCurrentEvaluation();
  }

  movePrevEvaluation() {
    if (!this.isFirst()) {
      this.currentIndex -= 1;
    }
    return this.getCurrentEvaluation();
  }

  getCurrentEvaluation() {
    return this.evaluations[this.currentIndex];
  }

  isFirst() {
    return this.currentIndex === 0;
  }
  isLast() {
    return this.currentIndex === this.evaluations.length - 1;
  }
}

function getEvaluationQuizBuilder() {
  return new EvaluationQuizBuilder();
}

function getEvaluationTaskBuilder() {
  return new EvaluationTaskBuilder();
}

function getEvaluationSelectAnswerBuilder() {
  return new EvaluationSelectAnswerBuilder();
}

function getEvaluationAddFileBuilder() {
  return new EvaluationAddFileBuilder();
}

function createAnswer(val, index) {
  return new Answer(val, index);
}

function createEvaluationDeck(evaluations) {
  return new EvaluationDeck(evaluations);
}

export default {
  getEvaluationQuizBuilder,
  getEvaluationTaskBuilder,
  getEvaluationSelectAnswerBuilder,
  getEvaluationAddFileBuilder,
  createAnswer,
  createEvaluationDeck,
};
